export default __webpack_public_path__ + "static/Morado_VP_Logo-8001091754cac860d55c439784ce6b4b.png";